
// Extending the Array prototype to add the removeAll function
export function removeAll<T>(array: T[], item: T): T[] {
  return array.filter((currentItem: T) => currentItem !== item);
};

// Extending the Array prototype to add the removeFirst function
export function removeFirst<T>(array: T[], item: T): T[] {
  const index = array.indexOf(item);
  if (index > -1) {
    array.splice(index, 1);
  }
  return array;
};

// Extending the Array prototype to add the distinct function
export function distinct<T>(array:Array<T>) : T[] {
  const unique = new Set<T>();
  array.forEach(item => {  unique.add(item); });
  return Array.from(unique);
};

// Returns distinct elements from the array based on a key selector function
export function distinctBy<T, K>(array: T[], keySelector: (item: T) => K): T[] {
  const seen = new Set<K>();
  return array.filter(item => {
    const key = keySelector(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

